<template>
  <div class="about">
    <banner />
    <div class="about-menu">
      <div class="section about-menu-list flex-row">
        <div
          v-for="(item, index) in menuRes"
          :key="item.name"
          :class="[
            'about-menu-item',
            { active: index == activeLink },
            'little_hand',
          ]"
          @click="toLink(item.link, index)"
        >
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div id="brief" class="brief section">
        <div class="column">
          <h2>Brief</h2>
        </div>
        <div class="brief-con" v-html="introRes.comRelatedContentEn"></div>
        <div class="tags">
          <div class="line"></div>
          <svg-icon icon-class="quotation-mark"></svg-icon>
          <h3>KARON ECO-VALVE, Focusing on People's Livelihood</h3>
          <p>
            {{ introRes.comRelatedDescripEn }}
            <!-- 民生用水，国之大计，冠龙一直在为保障居民用水安全，做大做强企业，打造出中国的知名的国际阀门品牌而努力！ -->
          </p>
        </div>
      </div>
      <div id="culture" class="culture section">
        <div class="column">
          <h2>Culture</h2>
        </div>
        <div class="culture-con items-center">
          <img src="@/assets/images/about02.png" />
          <div class="info flex-col justify-around">
            <div class="info-item">
              <h3>entrepreneurial spirit</h3>
              <p>KARON ECO-VALVE, Focusing on People's Livelihood！</p>
            </div>
            <div class="info-item">
              <h3>core value</h3>
              <p>Professionalism, Integrity, Commitment, Innovation！</p>
            </div>
            <div class="info-item">
              <h3>purpose</h3>
              <p>
                Customer satisfaction, employee pride, benefit the society！
              </p>
            </div>
            <div class="info-item">
              <h3>vision</h3>
              <p>Create a world-renowned valve manufacturing brand</p>
            </div>
            <div class="info-item">
              <h3>strategy</h3>
              <p>
                Break through traditional technology and accelerate scientific
                and technological innovation
              </p>
            </div>
            <div class="info-item">
              <h3>Quality policy</h3>
              <p>
                Fine quality, dare to innovate, excellent service, long water
                flow！
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="develop" class="develop-history">
        <div class="section">
          <div class="column">
            <h2>Development History</h2>
          </div>
          <div class="develop-history-swipe">
            <swiper type="5" :historyListRes="historyListRes"></swiper>
          </div>
        </div>
      </div>
      <div id="qualification" class="company-qualification">
        <img src="@/assets/images/about01.png" class="bg" />
        <div class="section">
          <div class="column">
            <h2>Company Qualification</h2>
          </div>
          <div class="company-qualification-swipe">
            <swiper type="6" :certificateListRes="certificateListRes"></swiper>
          </div>
        </div>
      </div>
      <div id="detectability" class="section detectability">
        <div class="column">
          <h2>Detectability</h2>
        </div>
        <div class="intro" v-if="detection"  v-html="detection.comRelatedDescripEn">
        </div>
        <div class="more items-center little_hand" @click="fnToWeb">
          introduction
          <svg-icon icon-class="direction"></svg-icon>
        </div>
      </div>
      <div id="project" class="section project-case">
        <div class="column">
          <h2>Project Case</h2>
        </div>
        <el-row :gutter="20">
          <el-col
            :span="isPc ? 8 : 24"
            v-for="item in cases"
            :key="item.comRelatedId"
          >
            <div
              class="project-info little_hand"
              @click="toCaseDetails(item.comRelatedId, item.url)"
            >
              <img :src="item.image" />
              <div class="title items-end">
                <h4 class="items-end">{{ item.titleEn }}</h4>
              </div>
              <div class="hover-info flex-col">
                <h5 class="items-end">{{ item.comRelatedDescripEn }}</h5>
                <svg-icon icon-class="direction"></svg-icon>
              </div>
            </div>
          </el-col>
        </el-row>
        <router-link :to="{ path: '/en_cases' }">
          <div class="more items-center justify-end little_hand">
            more
            <svg-icon icon-class="direction"></svg-icon>
          </div>
        </router-link>
      </div>
      <div id="info" class="section disclose-info">
        <div class="column">
          <h2>Disclose Information</h2>
        </div>
        <el-row :gutter="20">
          <el-col
            :span="isPc ? 12 : 24"
            v-for="item in InfoList"
            :key="item.comRelatedId"
          >
            <div
              class="info-item justify-between items-center little_hand"
              @click="toCaseDetails(item.comRelatedId, item.url)"
            >
              <div class="info-left">
                <h4 class="items-end">{{ item.titleEn }}</h4>
                <time>{{ item.time }}</time>
              </div>
              <svg-icon icon-class="direction"></svg-icon>
            </div>
          </el-col>
        </el-row>
        <router-link :to="{ path: '/en_disclose-info' }">
          <div class="more items-center justify-end little_hand">
            more
            <svg-icon icon-class="direction"></svg-icon>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../common/banner.vue";
import Swiper from "../common/swiper.vue";
import {
  getCertificateList,
  getHistoryList,
  getRelatedByCase,
  getRelatedByCulture,
  getRelatedByDetection,
  getRelatedByInfo,
  getRelatedByIntro,
} from "@/assets/api/about.js";

import { mapState } from "vuex";

export default {
  name: "about",
  components: {
    banner,
    Swiper,
  },
  data() {
    return {
      activeLink: 0,
      menuRes: [
        {
          name: "brief",
          link: "brief",
        },
        {
          name: "culture",
          link: "culture",
        },
        {
          name: "development",
          link: "develop",
        },
        {
          name: "qualification",
          link: "qualification",
        },
        {
          name: "detectability",
          link: "detectability",
        },
        {
          name: "project case",
          link: "project",
        },
        {
          name: "disclose information",
          link: "info",
        },
      ],
      certificateListRes: [],
      historyListRes: [],
      cases: [],
      detection: {},
      InfoList: [],
      introRes: {},
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    getCertificateList({
      orderByColumn: "orderNum",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 6,
    }).then((res) => {
      // console.log(res.data);
      this.certificateListRes = res.data.rows.map((item) => {
        item.certificateImage = !/^http/.test(item.certificateImage)
          ? this.$imgUrl + item.certificateImage
          : item.certificateImage;
        return item;
      });
    });
    getHistoryList({
      orderByColumn: "historyDate",
      isAsc: "desc",
    }).then((res) => {
      // console.log(res.data);
      this.historyListRes = res.data.data.map((item) => {
        item.year = this.$dayjs(item.historyDate).format("YYYY");
        var monthArray = new Array(
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        );
        item.month = monthArray[new Date(item.historyDate).getMonth()];
        return item;
      });
      // 按时间排序
      this.historyListRes
        .sort((a, b) => parseInt(a.historyDate) - parseInt(b.historyDate))
        .reverse();
      // 将相同的年份放一个对象里
      var result = [...new Set(this.historyListRes.map((row) => row.year))].map(
        (key) => ({
          year: key,
          values: this.historyListRes
            .filter((row) => row.year == key)
            .map((row) => {
              return {
                month: row.month,
                historyEn: row.historyEn,
              };
            }),
        })
      );
      this.historyListRes = result;
      // console.log(result);
    });
    getRelatedByCase({
      orderByColumn: "orderNum",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 3,
    }).then((res) => {
      // console.log(res.data);
      this.cases = res.data.data.rows.map((item) => {
        item.image = !/^http/.test(item.image)
          ? this.$imgUrl + item.image
          : item.image;
        return item;
      });
    });
    getRelatedByCulture().then((res) => {
      // console.log(res.data);
    });
    getRelatedByDetection().then((res) => {
      // console.log(res.data);
      if (res.data) {
        this.detection = res.data.data;
      }
    });
    getRelatedByInfo({
      orderByColumn: "orderNum",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 4,
    }).then((res) => {
      // console.log(res.data);
      this.InfoList = res.data.data.rows.map((item) => {
        item.time = this.formatTime(item.createTime);
        return item;
      });
    });
    getRelatedByIntro().then((res) => {
      // console.log(res.data);
      this.introRes = res.data.data;
    });
  },
  beforeUpdate() {
    if (this.$route.query.type) {
      this.menuRes.filter((item, index) => {
        if (item.link == this.$route.query.type) {
          this.activeLink = index;
          return;
        }
      });
      this.toLink(this.$route.query.type, this.activeLink);
    }
  },
  mounted() {
    // 监听滚动事件
    // window.addEventListener("scroll", this.onScroll);
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    fnToWeb() {
      window.open(this.detection.url, "_blank");
    },
    formatTime(time) {
      //通过 new 关键词来定义 Date 对象， Date 对象自动使用当前的日期和时间作为其初始值
      var date = new Date(time);
      //将月份名称存储在数组中
      var monthArray = new Array(
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      );

      var day = date.getDate();
      var month = date.getMonth();
      var year = date.getFullYear();
      var year = year < 2000 ? year + 1900 : year;
      var yy = year.toString().substr(2, 2);
      return day + "/" + monthArray[month] + "/" + yy;
    },
    toLink(id, index) {
      this.activeLink = index;
      // console.log(this.activeLink);
      var anchor = document.getElementById(id);
      anchor.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    },
    toCaseDetails(comRelatedId,url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          path: `/en_case-details/${comRelatedId}`,
        });
      }
    },
    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll(".content div");
      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop);
      });
      // 获取当前文档流的 scrollTop
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 定义当前点亮的导航下标
      let navIndex = 0;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是 n 了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n;
        }
      }
      // 把下标赋值给 vue 的 data
      this.activeLink = navIndex;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.about-menu {
  background: #f8f8fa;
  .about-menu-list {
    .about-menu-item {
      padding-right: 20px;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      color: #2c2c2e;
      line-height: 28px;
      span {
        padding: 14px 0;
        display: block;
      }
    }
    .active {
      font-weight: bold;
      color: #005bac;
      span {
        border-bottom: 2px solid #005bac;
      }
    }
  }
}
.section {
  width: 1000px;
  margin: auto;
  position: relative;
}
.column {
  padding-top: 60px;
  margin-bottom: 24px;

  h2 {
    font-size: 32px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #2c2c2e;
    line-height: 42px;
  }
}
.more {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  color: #005bac;
  letter-spacing: 0;
  font-weight: 400;
  .svg-icon {
    width: 32px;
    height: 16px;
    margin-left: 8px;
  }
}
.brief {
  .brief-con {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #2c2c2e;
    line-height: 28px;
    margin-bottom: 24px;
  }
  .tags {
    background: #f8f8fa;
    position: relative;
    padding: 24px 20px;
    .line {
      width: 86%;
      height: 4px;
      background: #005bac;
      position: absolute;
      top: -2px;
      left: 0;
    }
    .svg-icon {
      width: 96px;
      height: 96px;
      color: rgba($color: #005bac, $alpha: 0.08);
      position: absolute;
      top: -30px;
      right: 20px;
    }
    h3 {
      font-size: 20px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #005bac;
      line-height: 26px;
      margin-bottom: 8px;
    }
    p {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #2c2c2e;
      line-height: 24px;
    }
  }
}
.culture {
  .culture-con {
    img {
      width: 600px;
      height: 440px;
      object-fit: cover;
      margin-right: 40px;
    }
  }
  .info {
    height: 440px;

    h3 {
      font-size: 18px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #2c2c2e;
      line-height: 24px;
      margin-bottom: 8px;
    }
    p {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #2c2c2e;
      line-height: 22px;
    }
  }
}
.develop-history {
  margin-top: 80px;
  background: #f8f8fa;
  padding-bottom: 80px;
}
.company-qualification {
  position: relative;
  padding-bottom: 80px;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .column {
    h2 {
      color: #ffffff;
    }
  }
}
.detectability {
  border-bottom: 1px solid #e5e5ea;
  padding-bottom: 80px;
  .intro {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #2c2c2e;
    line-height: 28px;
    margin-bottom: 16px;
  }
}
.project-case {
  border-bottom: 1px solid #e5e5ea;

  .project-info {
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
      height: 420px;
      object-fit: cover;
    }
    .title {
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: 20px;

      height: 210px;
      background-image: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.64) 100%
      );
      border-bottom: 8px solid #005bac;
    }
    h4 {
      font-family: MicrosoftYaHei-Bold;
      font-size: 24px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 36px;
      height: 72px;
      font-weight: 700;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
    .hover-info {
      position: absolute;
      transition: all 0.5s;
      width: 100%;
      // height: 160px;
      background: #005bac;
      padding: 20px;
      color: #ffffff;
      h5 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 36px;
        font-weight: 700;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .svg-icon {
        width: 48px;
        height: 24px;
        margin-top: 24px;
      }
    }
  }
  .project-info:hover {
    .hover-info {
      bottom: 0;
    }
  }
  .more {
    margin-top: 40px;
    padding-bottom: 80px;
  }
}
.disclose-info {
  padding-bottom: 80px;
  .info-item {
    background: #f8f8fa;
    padding: 20px;
    margin-bottom: 20px;
    transition: all 0.3s;
    h4 {
      font-size: 18px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #2c2c2e;
      line-height: 24px;
    }
    time {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #aeaeb2;
      line-height: 22px;
      margin-top: 8px;
    }
    .svg-icon {
      width: 48px;
      height: 24px;
      color: #f8f8fa;
    }
  }
  .info-item:hover {
    background: #005bac;
    h4 {
      color: #ffffff;
    }
    time {
      color: rgba($color: #ffffff, $alpha: 0.8);
    }
    .svg-icon {
      color: #ffffff;
    }
  }
}
@media screen and (max-width: 768px) {
  .section {
    width: 100%;
    padding: 0 20px;
  }
  .column {
    padding-top: 60px;
    margin-bottom: 16px;

    h2 {
      font-size: 24px;
      line-height: 31px;
    }
  }
  .more {
    font-size: 14px;
    .svg-icon {
      width: 24px;
      height: 13px;
      margin-left: 4px;
    }
  }
  .about-menu {
    .about-menu-list {
      overflow-x: scroll;
      .about-menu-item {
        span {
          white-space: nowrap;
        }
      }
      .about-menu-item:last-child {
        padding-right: 0;
      }
    }
    .about-menu-list::-webkit-scrollbar {
      width: 0;
    }
  }
  .brief {
    .brief-con {
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 40px;
    }
    .tags {
      .line {
        width: 73%;
        top: -2px;
        left: 0;
      }
      .svg-icon {
        right: 0;
        top: -36px;
      }
    }
  }
  .culture {
    .culture-con {
      flex-direction: column;
      align-items: flex-start;
      img {
        width: 100%;
        height: 257px;
        margin-right: 0;
      }
    }
    .info {
      height: auto;
      h3 {
        margin-top: 24px;
      }
    }
  }
  .develop-history {
    margin-top: 60px;
    background: #f8f8fa;
    padding-bottom: 80px;
  }
  .company-qualification {
    padding-bottom: 64px;
  }
  .detectability {
    padding-bottom: 60px;
    .intro {
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 24px;
    }
  }
  .project-case {
    border-bottom: none;
    .project-info {
      margin-bottom: 16px;
      img {
        height: 456px;
      }
      h4 {
        height: 228px;
        font-size: 20px;
        line-height: 30px;
      }
      .hover-info {
        position: absolute;
        transition: all 0.5s;
        width: 100%;
        // height: 160px;
        background: #005bac;
        padding: 20px;
        color: #ffffff;
        h5 {
          font-family: MicrosoftYaHei-Bold;
          font-size: 24px;
          color: #ffffff;
          letter-spacing: 0;
          line-height: 36px;
          font-weight: 700;
        }
        .svg-icon {
          width: 48px;
          height: 24px;
          margin-top: 24px;
        }
      }
    }
    .project-info:hover {
      .hover-info {
        bottom: 0;
      }
    }
    .more {
      justify-content: flex-start;
      margin-top: 8px;
      padding-bottom: 60px;
      border-bottom: 1px solid #e5e5ea;
    }
  }
  .disclose-info {
    padding-bottom: 60px;
    .info-item {
      margin-bottom: 16px;
    }
    .more {
      justify-content: flex-start;
      margin-top: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/en/about-details/index.vue